import { render, staticRenderFns } from "./businessProfile.vue?vue&type=template&id=17ea558f&scoped=true&"
import script from "./businessProfile.vue?vue&type=script&lang=js&"
export * from "./businessProfile.vue?vue&type=script&lang=js&"
import style0 from "./businessProfile.vue?vue&type=style&index=0&id=17ea558f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ea558f",
  null
  
)

export default component.exports